<template>
  <div class="error403-wrapper">
    <ul>
      <li>
        <router-link to="/index">返回首页</router-link>
      </li>
      <li @click="reload">
        返回上页
      </li>
    </ul>
    <div class="error-con">
      <!--<p><img src="/dist/logo.png" alt="" /></p>-->
      <!--<img src="error404ImgSrc" width="506" alt="">-->

    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  export default {
    data() {
      return {
        error403ImgSrc: require('./error_403.png'),
        error404ImgSrc: require('./error_404.png')
      }
    },
    methods: {
      reload() {
        window.history.back();
      }
    }
  }
</script>

<style lang="stylus">
  .error403-wrapper {
    position: fixed
    width: 100%
    min-height: 100%
    /*background: #f3f7fa;*/
    /*background-size: 1920px 100%*/
    text-align: center
    /*display: flex*/
    /*flex-direction: column*/
    /*justify-content: center*/
    font-size: 0
    line-height: 1;
    background: #1B1A20 url('./404.png') no-repeat top center;
    /*background-size 100% 100%*/
    ul {
      margin-top: 620px;
      li {
        font-size: 20px;
        display: inline-block;
        vertical-align: top;
        width :190px;
        height: 50px;
        line-height: 50px;
        cursor: pointer;
        border-radius: 25px;
        margin-right: 45px;

        &:first-child{
          border: 1px solid #1093D0;
          color: #1093D0;
          a {
            color: #1093D0;
          }
        }
        &:first-child:hover {
          background :#1093D0;
          a {
            color: #fff;
          }
        }
        &:last-child {
          color: #161616
          margin-right: 0
          border: 1px solid #FF7E00
          background :#FF7E00;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// notFound.vue?b5ae3798